"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/FKFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_75)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_75`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9649 0V2.14737L8.79298 3.90877H11.9649V8.07018H7.81754L11.9649 10.3719V11.9789H10.0912L4.93333 9.10877V11.9789H1.03158V8.56842L-5.10877 11.9789H-6V9.83158L-2.82807 8.07018H-6V3.90877H-1.85263L-6 1.6V0H-4.12632L1.03158 2.86316V0H4.93333V3.41053L11.0737 0H11.9649Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.10526 0H1.85965V4.86316H-6V7.10877H1.85965V11.9789H4.10526V7.10877H11.9649V4.86316H4.10526V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.93335 8.07019L11.9649 11.979V10.8702L6.92633 8.07019H4.93335Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.93335 8.07019L11.9649 11.979V10.8702L6.92633 8.07019H4.93335Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.93333 8.07019L11.9649 11.979V10.8702L6.92632 8.07019H4.93333ZM-0.961403 8.07019L-6 10.8702V11.979L1.03158 8.07019H-0.961403Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M1.03158 3.90175L-6 0V1.10175L-0.961403 3.90175H1.03158Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M1.03158 3.90175L-6 0V1.10175L-0.961403 3.90175H1.03158Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M1.03158 3.90175L-6 0V1.10175L-0.961403 3.90175H1.03158ZM6.92632 3.90175L11.9649 1.10175V0L4.93333 3.90175H6.92632Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.9088 13.6281V7.31227C15.9088 6.71578 16.365 6.23859 16.9614 6.23859H25.4176C26 6.23859 26.4702 6.71578 26.4702 7.31227V13.6281C26.4702 18.9053 21.193 21.0175 21.193 21.0175C21.193 21.0175 15.9088 18.9053 15.9088 13.6281Z",
					fill: "#1F8BDE"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.9088 13.6281V7.31227C15.9088 6.71578 16.365 6.23859 16.9614 6.23859H25.4176C26 6.23859 26.4702 6.71578 26.4702 7.31227V13.6281C26.4702 18.9053 21.193 21.0175 21.193 21.0175C21.193 21.0175 15.9088 18.9053 15.9088 13.6281ZM21.4948 19.6842C22.0492 19.3684 22.6106 18.9824 23.1228 18.5123C24.5614 17.214 25.4106 15.607 25.4106 13.621V7.30525C25.4106 7.2842 16.9614 7.2842 16.9614 7.2842V13.621C16.9614 15.607 17.8106 17.214 19.2492 18.5123C19.8316 19.0386 20.4843 19.4877 21.186 19.8456C21.2843 19.8035 21.3825 19.7474 21.4948 19.6842Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18.3579 13.5719C18.1754 13.0175 18.4772 12.5684 19.0667 12.5684H23.3123C23.8877 12.5684 24.2105 13.0105 24.021 13.5719L23.6351 14.7298C23.4526 15.2842 23.0105 15.3754 22.5263 15.0105C22.5263 15.0105 22.7088 14.6737 21.186 14.6737C19.6632 14.6737 19.8456 15.0105 19.8456 15.0105C19.4175 15.4105 18.9263 15.2912 18.7368 14.7298C18.7439 14.7368 18.3579 13.5719 18.3579 13.5719Z",
					fill: "#187536"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.0807 12.5684C19.6491 12.6807 20.3298 11.5158 21.193 11.5158C22.1123 11.5158 22.7228 12.7158 23.3053 12.5684C23.8246 12.4421 24.3579 11.0105 24.3579 10.4562C24.3579 9.29124 22.9404 8.34387 21.193 8.34387C19.4456 8.34387 18.0281 9.29124 18.0281 10.4562C18.0211 11.0526 18.4912 12.4562 19.0807 12.5684ZM18.9825 18.9965C19.4175 19.0246 19.8597 18.8702 20.1895 18.5404L20.8211 17.9088C21.0246 17.7053 21.3474 17.7053 21.5509 17.9088L22.1825 18.5404C22.5123 18.8702 22.9544 19.0246 23.3825 18.9965C23.7544 18.9755 25.6632 16.6456 25.186 16.7088C24.8632 16.7509 24.5474 16.9053 24.2947 17.1509L24.2877 17.1579L23.6561 17.7895C23.4526 17.993 23.1298 17.993 22.9263 17.7895L22.2947 17.1579C21.6842 16.5404 20.6877 16.5404 20.0702 17.1509L20.0632 17.1579L19.4316 17.7895C19.2281 17.993 18.9053 17.993 18.7018 17.7895L18.0702 17.1579C17.8246 16.9123 17.5228 16.7649 17.207 16.7158C16.7368 16.6386 18.6175 18.9755 18.9825 18.9965ZM16.6035 14.7369C16.807 14.5333 17.1298 14.5333 17.3333 14.7369L17.9649 15.3684C18.5825 15.979 19.5719 15.979 20.1895 15.3684L20.8211 14.7369C21.0246 14.5333 21.3474 14.5333 21.5509 14.7369L22.1825 15.3684C22.8 15.979 23.7895 15.979 24.407 15.3684L25.0386 14.7369C25.2421 14.5333 25.5649 14.5333 25.7684 14.7369C25.7684 14.7369 26.1544 13.6983 25.9439 13.6211C25.3895 13.4176 24.7368 13.5369 24.2947 13.986L24.2877 13.993L23.6561 14.6246C23.4526 14.8281 23.1298 14.8281 22.9263 14.6246L22.2947 13.993C21.6842 13.3755 20.6877 13.3755 20.0702 13.986L20.0632 13.993L19.4316 14.6246C19.2281 14.8281 18.9053 14.8281 18.7018 14.6246L18.0702 13.993C17.6351 13.5579 17.0105 13.4316 16.4702 13.607C16.2526 13.6842 16.6035 14.7369 16.6035 14.7369Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_75`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as FKFlag };
